import type { ReactNode } from "react";

interface InfoCardProps {
  children: ReactNode;
  className?: string;
}

export function InfoCard({ children, className }: InfoCardProps) {
  return (
    <div className={`bg-bg-tertiary border border-stroke-primary rounded-2xl p-5 ${className ?? ""}`}>
      {children}
    </div>
  );
}
